import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useMemo} from 'react'

import {Category, DetailsProps} from '../../types'
import {formatWhiteListItemsProp, getFieldFromTaximiterPrice, getMinFromIntervals} from '../../utils'
import {DetailsList} from '../details-list'

const getIncludedUnitsFromTaximiter =
  (field: 'distance_price_intervals' | 'time_price_intervals') => (tariff: Category, zone: string) =>
    getMinFromIntervals(getFieldFromTaximiterPrice(field)(tariff, zone))
const getIncludedDistance = getIncludedUnitsFromTaximiter('distance_price_intervals')
const getIncludedTime = getIncludedUnitsFromTaximiter('time_price_intervals')

const PickupDetails: React.FC<DetailsProps> = ({tariff, zone, currencySign}) => {
  const t = useI18n()
  const items = useMemo(
    () =>
      formatWhiteListItemsProp([
        {
          // Минимальная стоимость
          label: t('tariffs.property.minimal_cost'),
          value: tariff?.minimal ?? null,
          unit: currencySign,
        },
        {
          // Включено километров
          label: t('tariffs.property.included_distance'),
          value: getIncludedDistance(tariff, zone),
          unit: t('tariffs.units.distance'),
        },
        {
          // Включено минут
          label: t('tariffs.property.included_time'),
          value: getIncludedTime(tariff, zone),
          unit: t('tariffs.units.time'),
        },
        {
          // Бесплатное ожидание
          label: t('tariffs.property.free_waiting'),
          value: tariff?.waiting_included ?? null,
          unit: t('tariffs.units.time'),
        },
      ]),
    [tariff, zone, currencySign, t],
  )

  return <DetailsList items={items} title={t('tariffs.block_title.landing')} />
}

export default PickupDetails
